export default "data:image/webp;base64,UklGRjAAAABXRUJQVlA4TCMAAAAvJ8AFAAVhthHPsI/0FPoUCCSZLjuYQCDFISx0/7PjO3xrPgA="